import "firebase/compat/storage";
import { call, takeLatest, put, delay, select } from "redux-saga/effects";
import { callApi } from "../../util/superAgentUtil";
import actions from "../actionType";
import { notification } from "../../util/notification";
import formatMsg from "../../util/formatMsg";
import Helper from "../../util/helper";
function* getInvoiceList(request) {
  try {

    const { firebase, startDate, endDate, accountId } = request.payload;
    let endpoint = `bookingoApi/invoice?startDate=${startDate}&endDate=${endDate}`;
    if (Helper.getLoggedInUserType(firebase).toLowerCase() === "account" || accountId) {
      endpoint = `bookingoApi/invoice?accountId=${accountId || firebase.user.id}&startDate=${startDate}&endDate=${endDate}`;
    }
    let response = yield call(callApi, firebase, "get", endpoint, {}, false, false, true);
    if (response.status == 200) {
      let invoiceList = response.body.data;
      // if (firebase.user.userType.toLowerCase() === 'teacher') {
      //   const studentIds = Helper.getStudentList()?.map(st => st?.id)?.filter(st => st);
      //   invoiceList = invoiceList.filter(inv => studentIds.includes(inv.studentId));
      // }
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, invoiceList }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to fetch invoice list", err);
  }
}

function* getStudentInvoiceList(request) {
  try {
    const { firebase, startDate, endDate } = request.payload;
    let endpoint = `bookingoApi/invoice/student?startDate=${startDate}&endDate=${endDate}`;
    let response = yield call(callApi, firebase, "get", endpoint, {}, false, false, true);
    if (response.status == 200) {
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, studentInvoiceList: response.body.data }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to fetch student invoice list", err);
  }
}

function* getStudentInvoiceListFromStudentId(request) {
  try {
    const { firebase, startDate, endDate, studentId } = request.payload;
    let endpoint = `bookingoApi/invoice/student/${studentId}?startDate=${startDate}&endDate=${endDate}`;
    let response = yield call(callApi, firebase, "get", endpoint, {}, false, false, true);
    if (response.status == 200) {
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, studentIdInvoiceList: response.body.data }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to fetch student invoices", err);
  }
}

function* getTransactions(request) {
  try {
    const { firebase, startDate, endDate, accountId } = request.payload;
    let endpoint = `bookingoApi/invoice/transaction?startDate=${startDate}&endDate=${endDate}`;
    if (Helper.getLoggedInUserType(firebase).toLowerCase() === "account" || accountId) {
      endpoint = `bookingoApi/invoice/transaction?accountId=${accountId || firebase.user.id}&startDate=${startDate}&endDate=${endDate}`;
    }
    let response = yield call(callApi, firebase, "get", endpoint, {}, false, false, true);
    if (response.status == 200) {
      let transactionList = response.body.data;
      transactionList.sort((a, b) => b.date - a.date);
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, transactionList }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to fetch transactions", err);
  }
}
function* getAllTaxes(request) {
  try {
    const { firebase } = request.payload;
    let endpoint = `bookingoApi/tax`;
    let response = yield call(callApi, firebase, "get", endpoint, {});
    if (response.status == 200) {
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, taxes: response.body.data }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to fetch taxes", err);
  }
}

function* getAllDiscounts(request) {
  try {
    const { firebase } = request.payload;
    let endpoint = `bookingoApi/discount`;
    let response = yield call(callApi, firebase, "get", endpoint, {});
    if (response.status == 200) {
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, discounts: response.body.data }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to fetch discounts", err);
  }
}

function* getAllPackages(request) {
  try {
    const { firebase } = request.payload;
    let endpoint = `bookingoApi/package/all/names?teacherId=` + firebase.user.id;
    let response = yield call(callApi, firebase, "get", endpoint, {}, false, false, true);
    if (response.status == 200) {
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, packages: response.body.data }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to fetch discounts", err);
  }
}

function* getPricePackByPackageId(request) {
  try {
    const { firebase, packageId } = request.payload;
    let endpoint = `bookingoApi/package/${packageId}/classPack`;
    let response = yield call(callApi, firebase, "get", endpoint, {});
    if (response.status == 200) {
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, pricingPackByPackageId: response.body.data }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to fetch discounts", err);
  }
}

function* getInvoiceById(request) {
  try {
    const { firebase, invoiceId } = request.payload;
    let endpoint = `bookingoApi/invoice/${invoiceId}`;
    let response = yield call(callApi, firebase, "get", endpoint, {});
    if (response.status == 200) {
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, invoiceLoader: false, invoice: response.body.data }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to fetch invoice", err);
  }
}

function* createInvoice(request) {
  try {
    const { firebase, formData } = request.payload;
    let endpoint = `bookingoApi/invoice`;
    let response = yield call(callApi, firebase, "post", endpoint, formData);
    if (response.status == 200) {
      notification("success", formatMsg("success.invoiceCreated"))
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, operationType: "CREATE_INVOICE_SUCCESS" }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to create invoice", err);
  }
}

function* editInvoice(request) {
  try {
    const { firebase, formData } = request.payload;
    let endpoint = `bookingoApi/invoice/${formData.id}`;
    let response = yield call(callApi, firebase, "post", endpoint, formData);
    if (response.status == 200) {
      notification("success", formatMsg("success.invoiceEdited"))
      // Auto-refresh PDF after edit (without sending email)
      yield call(callApi, firebase, "post", "bookingoApi/invoice/pdf", { id: formData.id, sendEmail: false });
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, operationType: "EDIT_INVOICE_SUCCESS" }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to edit invoice", err);
  }
}

function* createBooking(request) {
  try {
    const { firebase, requestPayload } = request.payload;
    let endpoint = `bookingoApi/booking`;
    let response = yield call(callApi, firebase, "post", endpoint, requestPayload);
    if (response.status == 200) {
      notification("success", formatMsg("success.bookingCreated"))
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, operationType: "CREATE_INVOICE_SUCCESS" }
      });
    }
    else {
      notification("error", response?.body?.message || formatMsg("error.occured"))
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to create invoice", err);
  }
}

function* addRefund(request) {
  try {
    const { firebase, requestPayload, invoiceId } = request.payload;
    let endpoint = `bookingoApi/refund/${invoiceId}`;
    let response = yield call(callApi, firebase, "post", endpoint, { ...requestPayload });
    if (response.status == 200) {
      notification("success", formatMsg("success.refundAdded"))
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, refetchInvoice: invoiceId }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to create invoice", err);
  }
}
function* addPayment(request) {
  try {

    const { firebase, requestPayload, invoiceId } = request.payload;
    let endpoint = `bookingoApi/payment/${invoiceId}`;
    let response = yield call(callApi, firebase, "post", endpoint, { ...requestPayload });
    if (response.status == 200) {
      notification("success", formatMsg("success.paymentAdded"))
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, refetchInvoice: invoiceId, operationType: "PAYMENT_RECORDED" }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to create invoice", err);
  }
}

function* deleteRefund(request) {
  try {
    const { firebase, requestPayload, invoiceId } = request.payload;
    let endpoint = `bookingoApi/refund/${invoiceId}`;
    let response = yield call(callApi, firebase, "delete", endpoint, { ...requestPayload });
    if (response.status == 200) {
      notification("success", formatMsg("success.refundDeleted"))
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, refetchInvoice: invoiceId }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to deleteRefund", err);
  }
}

function* deletePayment(request) {
  try {
    const { firebase, requestPayload, invoiceId } = request.payload;
    let endpoint = `bookingoApi/payment/${invoiceId}`;
    let response = yield call(callApi, firebase, "delete", endpoint, { ...requestPayload });
    if (response.status == 200) {
      notification("success", formatMsg("success.paymentDeleted"))
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, refetchInvoice: invoiceId }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to deletePayment", err);
  }
}

function* sendFeeReminder(request) {
  try {
    const { firebase, requestPayload } = request.payload;
    let endpoint = `bookingoApi/invoice/reminder`;
    let response = yield call(callApi, firebase, "post", endpoint, requestPayload);
    if (response.status == 200) {
      notification("success", formatMsg("success.feeReminder"))
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to send fee reminder", err);
  }
}

function* invoicePDF(request) {
  try {

    const { firebase, requestPayload } = request.payload;
    let endpoint = `bookingoApi/invoice/pdf`;
    let response = yield call(callApi, firebase, "post", endpoint, requestPayload);
    if (response.status == 200) {
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, invoicePDF: response.body.data, operationType: "INVOICE_PDF_FETCHED", refetchInvoice: requestPayload.id }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to send fee reminder", err);
  }
}

function* getPackageInvoiceList(request) {
  try {

    const { firebase, startDate, endDate, packageId } = request.payload;
    let endpoint = `bookingoApi/invoice/packageInvoiceList/${packageId}?startDate=${startDate}&endDate=${endDate}`;
    if (Helper.getLoggedInUserType(firebase).toLowerCase() === "account") {
      endpoint = `bookingoApi/invoice?accountId=${firebase.user.id}&startDate=${startDate}&endDate=${endDate}`;
    }
    let response = yield call(callApi, firebase, "get", endpoint, {}, false, false, true);
    if (response.status == 200) {
      let invoiceListByPackageId = response.body.data;
      // if (firebase.user.userType.toLowerCase() === 'teacher') {
      //   const studentIds = Helper.getStudentList()?.map(st => st?.id)?.filter(st => st);
      //   invoiceList = invoiceList.filter(inv => studentIds.includes(inv.studentId));
      // }
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, invoiceListByPackageId }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to fetch invoice list", err);
  }
}
function* getTransactionsByPackageId(request) {
  try {
    const { firebase, startDate, endDate, packageId } = request.payload;
    let endpoint = `bookingoApi/invoice/transaction/${packageId}?startDate=${startDate}&endDate=${endDate}`;
    let response = yield call(callApi, firebase, "get", endpoint, {}, false, false, true);
    if (response.status == 200) {
      let transactionListByPackageId = response.body.data;
      // const studentIds = Helper.getStudentList()?.map(st => st?.id)?.filter(st => st);
      // transactionList = transactionList.filter(trans => studentIds.includes(trans.studentId));
      yield put({
        type: actions.INVOICE_SAGA_SUCCESS,
        payload: { isLoading: false, transactionListByPackageId }
      });
    }
    else {
      yield put({ type: actions.INVOICE_SAGA_FAILED });
    }
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    yield put({ type: actions.INVOICE_SAGA_FAILED });
    console.log("failed to fetch transactions", err);
  }
}
// After Tap sends the payer back, ask the backend how the payment went. The backend checks with
// Tap itself, but the payer can land here a moment before Tap has settled the charge, so a
// "pending" answer is retried a few times before we tell the payer it is still processing.
const TAP_STATUS_MAX_ATTEMPTS = 5;
const TAP_STATUS_RETRY_DELAY_MS = 3000;

function* checkTapPaymentStatus(request) {
  const { tapTransactionId, source } = request.payload;
  // The booking page listens on the package slice; invoice pages listen on the parent slice.
  const successType = source === "accountPackage" ? actions.PACKAGE_SLICE_OPERATION : actions.PARENT_SAGA_SUCCESS;
  try {
    // The page schedules this check the moment it loads, when a guest's session may not be set up
    // yet — so read the current login state from the store rather than the copy captured back then.
    // callApi needs it to add the centerId the backend uses to find the payment.
    const firebase = (yield select((state: any) => state.login?.firebase)) || request.payload.firebase;
    // Last resort: without any login state callApi adds no centerId, so put it on the URL ourselves.
    const endpoint = firebase
      ? "bookingoApi/tap/checkStatus"
      : `bookingoApi/tap/checkStatus?centerId=${encodeURIComponent(Helper.getUrlParam("centerId") || "")}`;
    // A guest has no login session. Calling with auth would make callApi try to fetch a login
    // token, fail, and log the page out before the request is even sent — so guests call
    // without auth (the backend allows that for this route), same as getBookingDetailsByBookingPaymentMetadataId.
    const isLoggedOut = !firebase?.user?.id;
    let status = "pending";

    for (let attempt = 1; attempt <= TAP_STATUS_MAX_ATTEMPTS; attempt++) {
      try {
        const response = yield call(callApi, firebase, "post", endpoint, { transactionId: tapTransactionId }, isLoggedOut);
        status = response?.status === 200 ? response.body?.data?.status : "pending";
      } catch (err) {
        // A failed call (network blip, server error) says nothing about the payment — try again.
        Helper.notifyBugsnag(err, true);
        status = "pending";
      }
      if (status !== "pending") break;
      if (attempt < TAP_STATUS_MAX_ATTEMPTS) yield delay(TAP_STATUS_RETRY_DELAY_MS);
    }

    yield put({
      type: successType,
      payload: {
        isLoading: false,
        operationType: status === "success" ? "TAP_PAYMENT_SUCCESS" : (status === "failed" ? "TAP_PAYMENT_FAILED" : "TAP_PAYMENT_PENDING"),
      }
    });
  } catch (err) {
    Helper.notifyBugsnag(err, true);
    const failType = source === "accountPackage" ? actions.PACKAGE_SAGA_FAILED : actions.PARENT_SAGA_FAILED;
    yield put({
      type: failType,
      payload: { isLoading: false }
    });
  }
}

export default function* rootSaga() {
  yield takeLatest(actions.GET_INVOICE_LIST, getInvoiceList);
  yield takeLatest(actions.GET_STUDENT_INVOICE_LIST, getStudentInvoiceList);
  yield takeLatest(actions.GET_TRANSACTION_LIST, getTransactions);
  yield takeLatest(actions.GET_STUDENT_INVOICE_LIST_BY_STUDENT_ID, getStudentInvoiceListFromStudentId);
  yield takeLatest(actions.GET_ALL_TAXES, getAllTaxes);
  yield takeLatest(actions.GET_ALL_DISCOUNTS, getAllDiscounts);
  yield takeLatest(actions.GET_ALL_PACKAGES, getAllPackages);
  yield takeLatest(actions.CREATE_INVOICE, createInvoice);
  yield takeLatest(actions.EDIT_INVOICE, editInvoice);
  yield takeLatest(actions.CREATE_BOOKING, createBooking);
  yield takeLatest(actions.ADD_REFUND, addRefund);
  yield takeLatest(actions.ADD_PAYMENT, addPayment);
  yield takeLatest(actions.DELETE_REFUND, deleteRefund);
  yield takeLatest(actions.DELETE_PAYMENT, deletePayment);
  yield takeLatest(actions.SEND_FEE_REMINDER, sendFeeReminder);
  yield takeLatest(actions.INVOICE_PDF, invoicePDF);
  yield takeLatest(actions.GET_INVOICE_BY_ID, getInvoiceById);
  yield takeLatest(actions.GET_PRICE_PACK_BY_PACKAGE_ID, getPricePackByPackageId);
  yield takeLatest(actions.GET_PACKAGE_INVOICE_LIST, getPackageInvoiceList);
  yield takeLatest(actions.GET_TRANSACTION_LIST_BY_PACKAGE_ID, getTransactionsByPackageId);
  yield takeLatest(actions.CHECK_TAP_PAYMENT_STATUS, checkTapPaymentStatus);
}